
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/facilities/search",
      function () {
        return require("private-next-pages/facilities/search.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/facilities/search"])
      });
    }
  